import { render, staticRenderFns } from "./math-captcha.vue?vue&type=template&id=5875e5d8&"
import script from "./math-captcha.vue?vue&type=script&lang=js&"
export * from "./math-captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5875e5d8')) {
      api.createRecord('5875e5d8', component.options)
    } else {
      api.reload('5875e5d8', component.options)
    }
    module.hot.accept("./math-captcha.vue?vue&type=template&id=5875e5d8&", function () {
      api.rerender('5875e5d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/math-captcha.vue"
export default component.exports